export default __webpack_public_path__ + "static/media/750.71abdea8.jpg";